import { Box, styled } from "@mui/material";
import { OXFORD_BLUE } from "constants/colors";

export const SModalWrapper = styled(Box)({
  position: "fixed",
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
  zIndex: 1000,
});

export const SModalBackdrop = styled(Box)({
  position: "fixed",
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
  zIndex: 1000,
  backgroundColor: "rgba(0, 0, 0, 0.5)",
});

export const SModalContent = styled(Box)(({ theme }) => ({
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  backgroundColor: OXFORD_BLUE,
  zIndex: 1002,
  padding: theme.spacing(6),
  paddingTop: theme.spacing(0),
  borderRadius: theme.spacing(2),
  boxShadow: theme.shadows[24],
}));
